import React, { useEffect, useRef } from 'react';
import { Field } from 'react-final-form';
import Multiselect from 'react-widgets/lib/Multiselect'
import classNames from 'classnames';
import { ValidationError } from '../../../components';

import css from './ReloveEditListingForm.css';

let SizeItem = ({ item }) => (
  <span>
    {item.group ? (<strong>{item.group}: </strong>) : ''}
    {item.label}
  </span>
);

const ReloveSizeSelectComponent = props => {
  const {
    className,
    id,
    label,
    options,
    placeholder,
    input,
    meta,
    ...rest
  } = props;

  const multiselectRef = useRef(null);

  // Use effect to directly modify the input element
  useEffect(() => {
    if (multiselectRef.current) {
      // Find the input element inside the Multiselect
      const inputElement = multiselectRef.current.querySelector('input');
      if (inputElement) {
        // Make it read-only to prevent typing
        inputElement.readOnly = true;
        // Apply custom styles if needed
        inputElement.style.cursor = 'pointer';
      }
    }
  }, [multiselectRef]);

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;

  // Error message and input error styles are only shown if the
  // field has been touched and the validation has failed.
  const hasError = touched && invalid && error;

  const selectClasses = classNames(css.size, {
    [css.sizeSuccess]: valid,
    [css.sizeError]: hasError,
  });
  const inputProps = { 
    className: selectClasses, 
    id, 
    ...input, 
    ...rest,
    // Disable keyboard input
    onKeyDown: (e) => {
      // Prevent all keyboard input 
      e.preventDefault();
    }
  };

  return options ? (
    <section className={classNames(className, css.sizeContainer)} ref={multiselectRef}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <Multiselect
        value={input.value || []}
        containerClassName={selectClasses} 
        data={options}
        tagComponent={SizeItem}
        valueField="key"
        textField="label"
        placeholder={placeholder}
        inputProps={inputProps}
        groupBy={item => item.group ? item.group : ''}
        filter={false}
        search={false}
        messages={{
          emptyFilter: 'Parece que no tenemos esa opción',
        }}
        onChange={items => {
          if(items.length <= 2)
            input.onChange(items)
        }}
        busy={false}
      />
      <ValidationError fieldMeta={meta} />
    </section>
  ) : null;
}

const ReloveSizeSelectField = props => {
  return <Field component={ReloveSizeSelectComponent} {...props} />;
};

export default ReloveSizeSelectField;
